import React from 'react';
import PropTypes from 'prop-types';
import MaxWidthContainer from '../Containers/MaxWidthContainer';
import HorizontalScroll from '../Containers/HorizontalScroll';

const SecondaryMenu = ({ children }) => (
  <div className="secondary-menu bg-white border-bottom-1 border-color-grey--light">
    <MaxWidthContainer>
      <HorizontalScroll>
        {children}
      </HorizontalScroll>
    </MaxWidthContainer>
  </div>
);

SecondaryMenu.propTypes = {
  children: PropTypes.object.isRequired,
};

export default SecondaryMenu;



// WEBPACK FOOTER //
// ./library/app/components/Global/Menus/SecondaryMenu.js